export function getFirstQueryValue(value?: string | string[] | null) {
  return Array.isArray(value) ? value[0] : value
}
